<template>
  <b-card
    class="text-justify"
  >
    <h2
      class="text-center"
      style="color:#44a676;"
    >Instalaciones</h2>
    <hr>
    <b-card-body>
      <div class="text-center m-3">
        <p>
          <feather-icon
            icon="MapIcon"
            size="21"
            class="text-danger stroke-current"
          />
          Lerdo de Tejada No. 2469, Col. Arcos Sur. C.P. 44500
          Guadalajara, Jalisco. México.</p>
        <p><feather-icon
          icon="SmartphoneIcon"
          size="21"
          class="text-success stroke-current"
        /> 33-3669-5550 al 5559</p>
      </div>

      <div>
        <l-map
          :zoom="zoom"
          :center="center"
        >
          <l-tile-layer :url="url" />
          <l-marker :lat-lng="[20.67046, -103.379312]" />
        </l-map>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCardBody, BCard,
} from 'bootstrap-vue'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

import { Icon } from 'leaflet'

/* eslint-disable global-require */
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('@/assets/images/icons/marker-icon.png'),
  iconUrl: require('@/assets/images/icons/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    BCard,
    BCardBody,
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      // Map
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 15,
      center: [20.67046, -103.379312],
    }
  },

}
</script>
<style lang="scss">
.vue2leaflet-map{
  &.leaflet-container{
    height: 350px;
  }
}
</style>
